$shm_codex_app $mol_book2
	session_id? \
	server_url \http://127.0.0.1:4870
	new_session_title? \
	search_query? \
	Send_icon $mol_icon_send
	Stop_icon $mol_icon_stop
	Session* $mol_button_minor
		attr *
			^
			current <= session_current* false
		sub /
			<= session_title* \
		click? <=> session_select*? null
	Sessions_pick $mol_pick
		hint \Сессии Codex
		align \bottom_left
		trigger_content /
			<= Sessions_current $mol_view
				sub / <= session_current_title \
		bubble_content /
			<= Sessions_panel
	Message* $mol_card
		theme <= message_theme* \
		attr *
			^
			role <= message_role_key* \
		sub /
			<= Message_head* $mol_view
				sub /
					<= Message_role* $mol_paragraph
						title <= message_role* \
					<= Message_time* $mol_paragraph
						title <= message_time* \
			<= Message_text_box* $mol_view
				sub /
					<= Message_text* $shm_hitalama_text
						text <= message_text* \
	pages <= app_pages /
		<= Chat_page $mol_page
			title <= chat_title \Чат
			tools /
				<= Sessions_pick
				<= Chat_provider $mol_view
					sub / <= chat_provider \
				<= Chat_status $mol_view
					attr *
						^
						busy <= busy false
					sub / <= chat_status \
				<= Goal_settings $mol_pick
					hint \Цель
					trigger_content /
						<= Goal_settings_icon $mol_icon_target
					bubble_content /
						<= Goal $mol_view
							sub /
								<= Goal_head $mol_view
									sub /
										<= Goal_title $mol_view
											sub / \Цель
										<= Goal_status $mol_view
											sub / <= goal_status \
								<= Goal_input $mol_textarea
									hint \Что должен сделать Codex
									value? <=> goal_text? \
								<= Goal_actions $mol_view
									sub /
										<= Goal_set $mol_button_major
											sub / \Поставить цель
											click? <=> goal_set? null
										<= Goal_clear $mol_button_minor
											sub / \Очистить
											click? <=> goal_clear? null
			body <= chat_body /
				<= Messages_box $mol_view
					sub /
						<= Messages $mol_view
							sub <= message_rows /
			foot /
				<= Prompt $mol_textarea
					hint \Сообщение
					value? <=> prompt? \
					submit? <=> send? null
				<= Send $mol_button_minor
					hint <= send_hint \
					sub <= send_content /
					click? <=> send? null
	No_session $mol_view
		sub / \Выберите или создайте сессию
	Sessions_panel $mol_view
		sub /
			<= New_session_bar $mol_view
				sub /
					<= New_session_title $mol_string
						hint \Название новой сессии
						value? <=> new_session_title? \
						submit? <=> create? null
					<= Create $mol_button_major
						hint \Создать сессию
						sub /
							<= Create_icon $mol_icon_plus
						click? <=> create? null
			<= Search $mol_search
				hint \Найти сессию
				query? <=> search_query? \
			<= Sessions $mol_view
				sub <= session_rows /
